import { Box } from '@mui/system'
import { PropsWithChildren } from 'react'
import { useTheme } from '@mui/material/styles'
import { CardTitleContainer, CardTitleText } from './Card.styled'

export const CardTitle = ({
  title,
  children,
}: PropsWithChildren<{ title?: string }>) => {
  return (
    <CardTitleContainer
      sx={{
        borderBottom: `1px solid ${useTheme().palette.primary.main}`,
      }}
    >
      <CardTitleText>{title}</CardTitleText>
      <Box>{children}</Box>
    </CardTitleContainer>
  )
}
